export const BASIC_PADDING = 16;
export const FILTERS_MIN_WIDTH = 236;
